import { sharesOf } from "../general/dataAtoms/sharesOf";

/**
 * The share each amount has of the whole, as a fraction, in the order given.
 * The whole is what the gains add up to: an amount that is no gain is no part
 * of it and has no share, so the result is undefined for it.
 */
export function gainShares(values: readonly number[]): (number | undefined)[] {
  return sharesOf(values).map((percent, index) =>
    percent !== undefined && values[index] > 0 ? percent / 100 : undefined,
  );
}
